export default __webpack_public_path__ + "static/media/orange-candy.f106b2cd.png";